module.exports = require('./lib/index').default;


//////////////////
// WEBPACK FOOTER
// ./~/axios-retry/index.js
// module id = 105
// module chunks = 199194594041642 201052475613007